/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext.js';

// SVG Flag Components
function IndonesiaFlag() {
  return (
    <svg width="20" height="15" viewBox="0 0 20 15" className="rounded-sm">
      <rect width="20" height="7.5" fill="#FF0000" />
      <rect y="7.5" width="20" height="7.5" fill="#FFFFFF" />
    </svg>
  );
}

function UKFlag() {
  return (
    <svg width="20" height="15" viewBox="0 0 20 15" className="rounded-sm">
      <rect width="20" height="15" fill="#012169" />
      <path d="M0,0 L20,15 M20,0 L0,15" stroke="#ffffff" strokeWidth="1.5" />
      <path d="M0,0 L20,15 M20,0 L0,15" stroke="#C8102E" strokeWidth="1" />
      <path d="M10,0 L10,15 M0,7.5 L20,7.5" stroke="#ffffff" strokeWidth="3" />
      <path d="M10,0 L10,15 M0,7.5 L20,7.5" stroke="#C8102E" strokeWidth="2" />
    </svg>
  );
}

export default function LanguageToggle() {
  const { toggleLanguage, isIndonesian } = useLanguage();

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-green-700 hover:bg-green-800 transition-all duration-300 text-white border border-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
      title={isIndonesian ? 'Switch to English' : 'Ganti ke Bahasa Indonesia'}
    >
      {isIndonesian ? <UKFlag /> : <IndonesiaFlag />}
      <span className="text-sm font-medium">
        {isIndonesian ? 'EN' : 'ID'}
      </span>
    </button>
  );
}
